import * as dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
export function formatDateTime(date) {
  return date.toLocaleDateString('en-GB', {
    minute: 'numeric',
    hour: 'numeric',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).replace(/,/, '');
}
export const getTimeSince = time => {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const elapsed = Date.now() - time.getTime();

  if (elapsed < msPerMinute) {
    return Math.floor(elapsed / 1000) + ' seconds ago';
  } else if (elapsed < msPerHour) {
    const minutes = Math.floor(elapsed / msPerMinute);
    return minutes === 1 ? 'a minute ago' : `${minutes} minutes ago`;
  } else if (elapsed < msPerDay) {
    const hours = Math.floor(elapsed / msPerHour);
    return hours === 1 ? 'a hour ago' : `${hours} hours ago`;
  } else if (elapsed < msPerMonth) {
    const days = Math.floor(elapsed / msPerDay);
    return days === 1 ? 'a day ago' : `${days} days ago`;
  } else {
    return time.toLocaleDateString('en-GB', {
      minute: 'numeric',
      hour: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).replace(/,/, '');
  }
};
export const getRemainTime = timer => {
  if (timer < 60) {
    return '<1M';
  }

  const hours = Math.floor(timer / (60 * 60)).toString().padStart(2, '0');
  const minutes = Math.floor(timer % (60 * 60) / 60).toString().padStart(2, '0');
  return `${hours}H:${minutes}M`;
};
export const formatDateTimeByTimestamp = timestamp => {
  return getTimeSince(new Date(timestamp * 1000));
};
export const formatRemainTime = (time, {
  format = 'DD [days] HH [hours]',
  unit = 'seconds'
}) => {
  const duration = dayjs.duration(time, unit);
  return duration.format(format);
};
export const formatTimestamp = timestamp => {
  return {
    days: Math.floor(timestamp / 1000 / 60 / 60 / 24),
    hours: Math.floor(timestamp / 1000 / 60 / 60) % 24,
    minutes: Math.floor(timestamp / 1000 / 60) % 60,
    seconds: Math.floor(timestamp / 1000) % 60
  };
};
export const calculateTimeLeft = endTime => {
  if (!endTime) return 0;
  const timeLeft = endTime - new Date().getTime();
  return timeLeft > 0 ? Math.floor(timeLeft / 1000) : 0;
};
export const formatTimeSpan = timeLeft => {
  if (timeLeft < 0) {
    return '0s';
  }

  const {
    days,
    hours,
    minutes,
    seconds
  } = formatTimestamp(timeLeft * 1000);
  return days > 0 ? `${days}d ${hours}h ${minutes}m` : timeLeft >= 60 ? `${hours}h ${minutes}m` : `${minutes}m ${seconds}s`;
};
export const timeInTwoDigits = time => {
  return time.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
};
export const formatTimeSpanMilliseconds = timeLeft => {
  const {
    days,
    hours,
    minutes,
    seconds
  } = formatTimestamp(timeLeft);

  if (days > 0) {
    return `${timeInTwoDigits(days)}d ${timeInTwoDigits(hours)}h ${timeInTwoDigits(minutes)}m`;
  } else if (hours > 0) {
    return `${timeInTwoDigits(hours)}h ${timeInTwoDigits(minutes)}m`;
  }

  return `${timeInTwoDigits(minutes)}m ${timeInTwoDigits(seconds)}s`;
};